import MarkdownContent from "./MarkdownContent";

import { createContext, useContext } from "react";

export const MarkdownContentContext = createContext(MarkdownContent);

export function useMarkdownContent() {
    return useContext(MarkdownContentContext);
}
